<template>
  <div>
    <profession-form :data-user="userToAddon"
                     :current-user="currentUser"
                     :availableServices="servicesOptions"
                     :availableHubs="hubsOptions"
                     :availableOccupations="occupationsOptions"
                     :is-manager="isManager"
                     :collapseHubs="true"
                     :field-name-addition="index"
                     :small="true"
                     :corporationHasProvider="corporationHasProvider"
                     @change="onProfessionFormChange" />
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { roles } from '@/settings/roles'
  import { getManageableResources } from '@/backend/users'
  import { getEntityResourceByCode } from '@/backend/entities'
  import ProfessionForm from '@/components/candidate/ProfessionForm'

  export default {
    name: 'CandidateAddonInfo',
    components: {
      ProfessionForm
    },
    props: [
      'entityId',
      'addOn',
      'index',
      'occupations',
      'checkValid',
      'isManager',
      'entityCode',
      'entity',
    ],
    data() {
      return {
        servicesOptions: [],
        occupationsOptions: [],
        hubsOptions: [],
        user: { ...this.addOn }
      }
    },
    computed: {
      ...mapGetters({
        currentUser: 'auth/currentUser',
      }),
      userToAddon() {
        return {
          entity_id: this.entityId,
          entity: this.entity,
          resource_type: this.user.resource_type,
          affiliated_service: this.user.affiliated_service,
          services: this.user.services,
          occupations: this.user.occupations,
          unavailability_dates_provider_id: this.user.unavailability_dates_provider_id,
          function: this.user.function
        }
      },
      cannotEditService(){
        return this.user.role == roles.recruiter
      },
      corporationHasProvider() {
        return this.entity.corporation.unavailability_dates_provider != null && this.entity.corporation.unavailability_dates_provider != ""
      }
    },
    methods: {
      onProfessionFormChange(value) {
        this.user.resource_type = value.resource_type
        this.user.affiliated_service = value.affiliated_service
        this.user.services = value.services
        this.user.occupations = value.occupations
        this.user.unavailability_dates_provider_id = value.unavailability_dates_provider_id
        this.user.function = value.function
      },
    },
    mounted() {
      const resourceFetcher = this.entityCode ? getEntityResourceByCode(this.entityCode) : getManageableResources(this.entityId)
      resourceFetcher.then(response => {
        const resource = response.data
        this.servicesOptions = resource.all_services
        this.occupationsOptions = resource.occupations
        this.hubsOptions = resource.hubs
        const occupationIds = resource.occupations.map(occupation => occupation.id)
        let validOccupations = []
        this.occupations.forEach(occupation => {
          if (occupationIds.includes(occupation.id)) {
            validOccupations.push(occupation)
          }
        })
        this.user.occupations = validOccupations
      })
    },
    watch: {
      checkValid: function() {
        if (this.checkValid) {
          this.$validator.validateAll().then((result) => {
            let addOnToValidate = {
              ...this.user,
              selected: true,
              index: this.index,
              entity_id: this.entityId,
              entity: this.entity
            }
            this.$emit('onCheckValidChange', result, addOnToValidate)
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/users/CandidateAddonInfo.vue